import { BankAccountType } from './bank-account-type';
import { Money } from '@lsq-frontend/remote-services/all-java/common-mk0';

export class RedactedBankAccount {
    public bankAccountKey: string;
    public bankName: string;
    public accountName: string;
    public redactedAccountNumber: string;
    public isDefault: boolean;
    public isVerified: boolean;
    public bankAccountType: BankAccountType;
    public refSwiftWireDetailKey: string;
    public countryCode: string;
    public refCompanyAddressKey: string;
    public wireFeeCents: Money;
    public routingNumber: string;
    constructor(obj?: {
       bankAccountKey?: string;
       bankName?: string;
       accountName?: string;
       redactedAccountNumber?: string;
       isDefault?: boolean;
       isVerified?: boolean;
       bankAccountType?: BankAccountType;
       refSwiftWireDetailKey?: string;
       countryCode?: string;
       refCompanyAddressKey?: string;
       wireFeeCents?: Money;
       routingNumber?: string;
    }) {
        if (obj != null) {
            this.bankAccountKey = typeof obj.bankAccountKey === 'undefined' ? this.bankAccountKey : obj.bankAccountKey;
            this.bankName = typeof obj.bankName === 'undefined' ? this.bankName : obj.bankName;
            this.accountName = typeof obj.accountName === 'undefined' ? this.accountName : obj.accountName;
            this.redactedAccountNumber = typeof obj.redactedAccountNumber === 'undefined' ? this.redactedAccountNumber : obj.redactedAccountNumber;
            this.isDefault = typeof obj.isDefault === 'undefined' ? this.isDefault : obj.isDefault;
            this.isVerified = typeof obj.isVerified === 'undefined' ? this.isVerified : obj.isVerified;
            this.bankAccountType = typeof obj.bankAccountType === 'undefined' ? this.bankAccountType : obj.bankAccountType;
            this.refSwiftWireDetailKey = typeof obj.refSwiftWireDetailKey === 'undefined' ? this.refSwiftWireDetailKey : obj.refSwiftWireDetailKey;
            this.countryCode = typeof obj.countryCode === 'undefined' ? this.countryCode : obj.countryCode;
            this.refCompanyAddressKey = typeof obj.refCompanyAddressKey === 'undefined' ? this.refCompanyAddressKey : obj.refCompanyAddressKey;
            this.wireFeeCents = typeof obj.wireFeeCents === 'undefined' ? this.wireFeeCents : obj.wireFeeCents;
            this.routingNumber = typeof obj.routingNumber === 'undefined' ? this.routingNumber : obj.routingNumber;
        }
    }
}
